const module = {
  firestorePath: 'business',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'business',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      category: {},
      subcategory: {},
      author: {},
      sales: {},

      sourceId: '',
      contractNumber: '',
      slug: '',

      logoUrl: '',
      thumbnailUrl: '',
      bannerUrl: '',

      name: '',
      titleId:'',
      titleEn: '',
      descriptionId: '',
      descriptionEn: '',
      excerptId: '',
      excerptEn: '',

      email: '',
      phone: '',
      address: '',
      workHour: {},
      socmedLink: {
        facebook: '',
        instagram: '',
        twitter: '',
        whatsapp: ''
      },
      counter: {
        likes: 0,
        hits: 0,
        posts: 0
      },

      dateRegister: null,
      dateExpired: null,
      dateRenewal: null,
      priceRegister: 0,
      priceRenewal: 0,
      billingCycle: 12,

      status: '',
      isDeleted: false
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => Object.values(state.data)
  },
  mutations: {},
  actions: {},
}

export default module
